<script lang="ts" setup>
import type { ProductPage } from "@/types";

defineProps<{ blok: ProductPage; uuid: string }>();
</script>

<template>
  <div v-editable="blok">
    <ProductBannerGallery
      v-if="blok?.bannerGallery"
      :product="blok"
      :uuid="uuid"
    />
    <ProductInformation v-if="blok?.sections" :product="blok" :uuid="uuid" />

    <div v-if="blok && blok.body">
      <component
        :is="item.component"
        v-for="item in blok.body"
        :key="item._uid"
        :blok="item"
      />
    </div>
  </div>
</template>
